import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Components
import CaseInfoCard from "../../components/CaseInfoCard";
import CaseSharingCard from "../../components/CaseSharingCard";
import IncidentWizard from "../../components/IncidentWizard";
import RecentPendingStatements from "../../components/RecentPendingStatements";
import SectionWrapper from "../../components/SectionWrapper";
import VictimInfoCard from "../../components/VictimInfoCard";

const useStyles = makeStyles(theme => ({
  cards: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2)
  }
}));

const CaseDetailPage = () => {
  const { data } = useSelector(state => state.caseDetail);
  const classes = useStyles();
  const [wizardDismissed, setWizardDismissed] = useState(false);

  useEffect(() => {
    setWizardDismissed(false);
  }, [data?.id]);

  // Matches iOS exactly: all three empty, owner only, not gated on draft
  // status (in practice a submitted case always has data anyway) - and not
  // "owner or victim" either, that's the separate Evidence Score banner's
  // rule (CaseInfoCard/CaseCard), not this one.
  const isIncidentEmpty = !(
    data?.incident?.descriptions?.length ||
    data?.incident?.dateTime ||
    data?.incident?.location
  );
  const needsWizard =
    data?.isOwnedByUser && isIncidentEmpty && !wizardDismissed;

  return (
    <SectionWrapper hideSidebar={needsWizard}>
      {data &&
        (needsWizard ? (
          <IncidentWizard
            caseId={data.id}
            incident={data.incident}
            onComplete={() => setWizardDismissed(true)}
          />
        ) : (
          <div className={classes.cards}>
            <VictimInfoCard data={data} />
            <CaseInfoCard data={data} />
            <CaseSharingCard data={data} />
            <RecentPendingStatements caseId={data.id} />
          </div>
        ))}
    </SectionWrapper>
  );
};

export default CaseDetailPage;
